(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-style3"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
    document.querySelectorAll('.up-country-switcher[open]').forEach(selector => {
      if (!selector.contains(event.target)) selector.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.up-country-switcher[open]').forEach(selector => {
      selector.open = false;
      selector.querySelector('summary').focus();
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["up-card-quick-add"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('up-card-quick-add')) {
  let quickAddSequence = 0;
  let quickAddQueue = Promise.resolve();
  customElements.define('up-card-quick-add', class extends HTMLElement {
    connectedCallback() {
      if (this.upQuickReady) return;
      const data = this.querySelector('[data-up-qa-data]');
      if (!data) return;
      try { this.config = JSON.parse(data.textContent); } catch { return; }
      if (!this.config.variants?.length) return;
      this.upQuickReady = true;
      this.controller = new AbortController();
      this.shell = this.querySelector('[data-up-qa-shell]');
      this.trigger = this.querySelector('[data-up-qa-trigger]');
      this.panel = this.querySelector('[data-up-qa-panel]');
      this.status = this.querySelector('[data-up-qa-status]');
      this.variantList = this.querySelector('[data-up-qa-variants]');
      this.card = this.closest('.up-product, product-card');
      this.panel.id = `UPQuickAdd-${++quickAddSequence}`;
      this.trigger.setAttribute('aria-controls', this.panel.id);
      this.selected = [...(this.config.variants.find(variant => variant.available) || this.config.variants[0]).options];
      this.selects = [];
      this.querySelector('[data-up-qa-options]').replaceChildren();
      this.config.options.slice(0, -1).forEach((name, index) => {
        const label = document.createElement('label');
        label.className = 'up-qa-option';
        const title = document.createElement('span');
        title.textContent = name;
        const select = document.createElement('select');
        select.dataset.optionIndex = String(index);
        [...new Set(this.config.variants.map(variant => variant.options[index]))].forEach(value => select.add(new Option(value, value)));
        label.append(title, select);
        this.querySelector('[data-up-qa-options]').append(label);
        this.selects.push(select);
      });
      this.refreshOptions();
      this.shell.hidden = false;
      this.querySelector('[data-up-qa-fallback]').hidden = true;
      const options = { signal: this.controller.signal };
      this.trigger.addEventListener('click', () => {
        if (this.busy) return;
        this.pinned = !this.pinned || this.panel.hidden;
        this.setOpen(this.pinned);
      }, options);
      this.addEventListener('change', event => {
        const index = Number(event.target.dataset.optionIndex);
        if (!Number.isInteger(index) || !this.selects.includes(event.target)) return;
        this.selected[index] = event.target.value;
        const candidate = this.config.variants.find(variant => variant.available && variant.options.every((value, position) => position > index || value === this.selected[position]));
        if (candidate) this.selected = [...candidate.options];
        this.status.textContent = '';
        this.refreshOptions();
      }, options);
      this.variantList.addEventListener('click', event => {
        const button = event.target.closest('[data-variant-id]');
        if (!button || button.disabled || this.busy) return;
        const variant = this.config.variants.find(item => String(item.id) === button.dataset.variantId);
        if (variant?.available) this.queueAdd(variant, button);
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || this.panel.hidden || this.busy) return;
        event.preventDefault();
        event.stopPropagation();
        this.pinned = false;
        this.setOpen(false);
        this.trigger.focus({ preventScroll: true });
      }, options);
      this.card?.addEventListener('pointerenter', event => {
        if (event.pointerType === 'touch' || !matchMedia('(min-width: 768px) and (hover: hover) and (pointer: fine)').matches) return;
        clearTimeout(this.closeTimer);
        this.setOpen(true);
      }, options);
      this.card?.addEventListener('pointerleave', event => {
        if (event.pointerType === 'touch' || !matchMedia('(min-width: 768px) and (hover: hover) and (pointer: fine)').matches) return;
        this.closeTimer = setTimeout(() => {
          if (!this.pinned && !this.busy && !this.contains(document.activeElement)) this.setOpen(false);
        }, 160);
      }, options);
      this.addEventListener('focusout', () => {
        queueMicrotask(() => {
          if (!this.isConnected || this.busy || this.pinned || this.contains(document.activeElement)) return;
          if (!this.card?.matches(':hover')) this.setOpen(false);
        });
      }, options);
    }
    disconnectedCallback() {
      this.controller?.abort();
      clearTimeout(this.closeTimer);
      this.upQuickReady = false;
    }
    setOpen(open) {
      this.panel.hidden = !open;
      this.trigger.setAttribute('aria-expanded', String(open));
      this.trigger.querySelector('.up-qa-sign').textContent = open ? '−' : '+';
    }
    refreshOptions() {
      this.selects.forEach((select, index) => {
        [...select.options].forEach(option => {
          option.disabled = !this.config.variants.some(variant => variant.available && variant.options[index] === option.value && variant.options.every((value, position) => position >= index || value === this.selected[position]));
        });
        select.value = this.selected[index];
      });
      const finalIndex = this.config.options.length - 1;
      const values = [...new Set(this.config.variants.map(variant => variant.options[finalIndex]))];
      this.variantList.replaceChildren();
      values.forEach(value => {
        const variant = this.config.variants.find(item => item.options.every((option, index) => option === (index === finalIndex ? value : this.selected[index])));
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'up-qa-variant';
        button.disabled = !variant?.available;
        if (variant) button.dataset.variantId = String(variant.id);
        const name = document.createElement('span');
        name.textContent = this.config.defaultVariant ? this.config.strings.add : value;
        const detail = document.createElement('span');
        detail.className = 'up-qa-variant-price';
        detail.textContent = !variant ? this.config.strings.unavailable : !variant.available ? this.config.strings.soldOut : variant.price;
        button.setAttribute('aria-label', variant?.available ? this.config.strings.addVariant.replace('__VARIANT__', this.config.defaultVariant ? this.config.title : variant.title) : `${name.textContent}: ${detail.textContent}`);
        button.append(name, detail);
        this.variantList.append(button);
      });
    }
    queueAdd(variant, button) {
      this.busy = true;
      this.pinned = true;
      this.setAttribute('aria-busy', 'true');
      this.status.textContent = this.config.strings.adding;
      const controls = [...this.querySelectorAll('select, .up-qa-variant')].map(control => [control, control.disabled]);
      controls.forEach(([control]) => { control.disabled = true; });
      quickAddQueue = quickAddQueue.catch(() => {}).then(() => this.addVariant(variant)).finally(() => {
        this.busy = false;
        this.removeAttribute('aria-busy');
        controls.forEach(([control, disabled]) => { control.disabled = disabled; });
        if (this.isConnected && document.activeElement === document.body) button.focus({ preventScroll: true });
      });
    }
    async addVariant(variant) {
      const routes = window.theme?.routes || {};
      const root = window.Shopify?.routes?.root || '/';
      const sections = [
        { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
        { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
        { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
      ].filter(section => document.getElementById(section.id));
      let response;
      try {
        const result = await fetch(routes.cart_add_url || `${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }], sections: sections.map(section => section.section), sections_url: window.location.pathname })
        });
        response = await result.json();
        if (!result.ok || response.status) throw new Error(typeof response.description === 'string' ? response.description : this.config.strings.error);
      } catch (error) {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        if (this.isConnected) this.status.textContent = error.message && !['TypeError', 'SyntaxError'].includes(error.name) ? error.message : this.config.strings.error;
        return;
      }
      let refreshRequired = false;
      sections.forEach(section => {
        const container = document.getElementById(section.id);
        const html = response.sections?.[section.section];
        if (!container || typeof html !== 'string') { refreshRequired = true; return; }
        const content = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector);
        if (!content) { refreshRequired = true; return; }
        (container.querySelector(section.selector) || container).innerHTML = content.innerHTML;
      });
      document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { product: response.items?.[0] || response } }));
      if (refreshRequired) document.dispatchEvent(new CustomEvent('cart:refresh'));
      if (this.isConnected) this.status.textContent = this.config.strings.added;
      const drawer = document.getElementById('Cart-Drawer');
      if (typeof drawer?.open === 'function') drawer.open();
      else if (!document.getElementById('Cart')) window.location.assign(routes.cart_url || `${root}cart`);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["up-header-search"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('up-header-search')) {
  let upSearchSequence = 0;
  customElements.define('up-header-search', class extends HTMLElement {
    connectedCallback() {
      if (this.upSearchReady) return;
      this.form = this.querySelector('form');
      this.input = this.querySelector('.up-search-input');
      this.panel = this.querySelector('.up-search-panel');
      this.results = this.querySelector('.up-search-results');
      this.message = this.querySelector('[data-up-search-message]');
      this.status = this.querySelector('[data-up-search-status]');
      this.clearButton = this.querySelector('.up-search-clear');
      this.allLink = this.querySelector('.up-search-all');
      if (!this.form || !this.input || !this.panel || !this.results) return;
      this.upSearchReady = true;
      this.revision = (this.revision || 0) + 1;
      this.events = new AbortController();
      this.results.id = `UPSearchResults-${++upSearchSequence}`;
      this.input.setAttribute('role', 'combobox');
      this.input.setAttribute('aria-autocomplete', 'list');
      this.input.setAttribute('aria-haspopup', 'listbox');
      this.input.setAttribute('aria-controls', this.results.id);
      this.input.setAttribute('aria-expanded', 'false');
      this.clearButton.hidden = !this.input.value;
      this.activeIndex = -1;
      this.close();
      const options = { signal: this.events.signal };
      this.input.addEventListener('input', event => { if (!event.isComposing) this.schedule(); }, options);
      this.input.addEventListener('compositionend', () => this.schedule(), options);
      this.input.addEventListener('focus', () => {
        if (this.suppressFocus) return;
        const query = this.input.value.trim();
        if (query && this.renderedQuery === query) this.open();
        else if (query) this.schedule();
      }, options);
      this.input.addEventListener('keydown', event => this.onKeydown(event), options);
      this.form.addEventListener('submit', event => {
        if (!this.input.value.trim()) { event.preventDefault(); this.input.focus(); }
        else this.close();
      }, options);
      this.clearButton.addEventListener('click', () => {
        this.input.value = '';
        this.renderedQuery = '';
        this.schedule();
        this.input.focus();
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || this.panel.hidden) return;
        event.preventDefault();
        event.stopPropagation();
        this.close();
        this.suppressFocus = true;
        this.input.focus({ preventScroll: true });
        this.suppressFocus = false;
      }, options);
      this.panel.addEventListener('pointerdown', event => {
        if (event.button === 0 && event.target.closest('a')) event.preventDefault();
      }, options);
      this.addEventListener('focusout', event => {
        if (event.relatedTarget && this.contains(event.relatedTarget)) return;
        clearTimeout(this.focusTimer);
        this.focusTimer = setTimeout(() => {
          if (this.isConnected && !this.contains(document.activeElement)) this.close();
        }, 0);
      }, options);
      document.addEventListener('pointerdown', event => { if (!this.contains(event.target)) this.close(); }, options);
      document.addEventListener('cart-drawer:open', () => this.close(), options);
      this.closest('theme-header')?.addEventListener('toggle', event => {
        if (event.target.matches?.('.up-mega-disclosure') && event.target.open) this.close();
      }, { capture: true, signal: this.events.signal });
      document.addEventListener('up:search-open', event => { if (event.detail?.source !== this) this.close(); }, options);
      const viewportOptions = { passive: true, signal: this.events.signal };
      const updateRoom = () => this.queueRoomUpdate();
      window.addEventListener('resize', updateRoom, viewportOptions);
      window.addEventListener('scroll', updateRoom, viewportOptions);
      window.visualViewport?.addEventListener('resize', updateRoom, viewportOptions);
      window.visualViewport?.addEventListener('scroll', updateRoom, viewportOptions);
    }
    disconnectedCallback() {
      this.events?.abort();
      clearTimeout(this.focusTimer);
      cancelAnimationFrame(this.roomFrame);
      this.roomFrame = null;
      this.cancelRequest();
      this.upSearchReady = false;
    }
    cancelRequest() {
      clearTimeout(this.timer);
      this.request?.abort();
      this.revision = (this.revision || 0) + 1;
      this.panel?.removeAttribute('aria-busy');
    }
    schedule() {
      this.cancelRequest();
      const query = this.input.value.trim();
      this.clearButton.hidden = !this.input.value;
      this.renderedQuery = '';
      this.results.replaceChildren();
      this.activeIndex = -1;
      this.input.removeAttribute('aria-activedescendant');
      this.status.textContent = '';
      if (!query) { this.message.textContent = ''; this.close(); return; }
      this.message.textContent = this.dataset.loading;
      this.setAllLink(query);
      this.open();
      const revision = this.revision;
      this.timer = setTimeout(() => this.search(query, revision), 200);
    }
    async search(query, revision) {
      if (!this.isConnected || revision !== this.revision || this.input.value.trim() !== query) return;
      this.request = new AbortController();
      this.panel.setAttribute('aria-busy', 'true');
      try {
        const endpoint = new URL(this.dataset.predictiveUrl, window.location.origin);
        if (!endpoint.pathname.endsWith('.json')) endpoint.pathname += '.json';
        endpoint.search = new URLSearchParams({ q: query, 'resources[type]': 'product', 'resources[limit]': '6', 'resources[limit_scope]': 'each', 'resources[options][unavailable_products]': 'last' }).toString();
        const response = await fetch(endpoint, { signal: this.request.signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Search unavailable');
        const data = await response.json();
        if (!this.isConnected || revision !== this.revision || this.input.value.trim() !== query) return;
        if (!Array.isArray(data.resources?.results?.products)) throw new Error('Invalid search response');
        this.renderProducts(data.resources.results.products.slice(0, 6), query);
      } catch (error) {
        if (error.name === 'AbortError' || !this.isConnected || revision !== this.revision || this.input.value.trim() !== query) return;
        this.results.replaceChildren();
        this.message.textContent = this.dataset.error;
        this.status.textContent = this.dataset.error;
        this.renderedQuery = '';
      } finally {
        if (this.isConnected && revision === this.revision) this.panel.removeAttribute('aria-busy');
      }
    }
    renderProducts(products, query) {
      const fragment = document.createDocumentFragment();
      let count = 0;
      products.forEach(product => {
        if (!product.title || !product.url) return;
        let url;
        try { url = new URL(product.url, window.location.origin); } catch { return; }
        if (url.origin !== window.location.origin || !['https:', 'http:'].includes(url.protocol)) return;
        count += 1;
        const item = document.createElement('li');
        item.setAttribute('role', 'presentation');
        const link = document.createElement('a');
        link.href = url.href;
        link.className = 'up-search-result';
        link.id = `${this.results.id}-${count}`;
        link.tabIndex = -1;
        link.setAttribute('role', 'option');
        link.setAttribute('aria-selected', 'false');
        const index = document.createElement('span');
        index.className = 'up-search-result-index';
        index.setAttribute('aria-hidden', 'true');
        index.textContent = String(count).padStart(2, '0');
        const copy = document.createElement('span');
        copy.className = 'up-search-result-copy';
        const title = document.createElement('span');
        title.className = 'up-search-result-title';
        title.textContent = product.title;
        copy.append(title);
        if (product.type || product.product_type) {
          const type = document.createElement('span');
          type.className = 'up-search-result-type';
          type.textContent = product.type || product.product_type;
          copy.append(type);
        }
        const arrow = document.createElement('span');
        arrow.className = 'up-search-result-arrow';
        arrow.setAttribute('aria-hidden', 'true');
        arrow.textContent = '↗';
        link.append(index, copy, arrow);
        item.append(link);
        fragment.append(item);
      });
      this.results.replaceChildren(fragment);
      this.renderedQuery = query;
      this.activeIndex = -1;
      this.input.removeAttribute('aria-activedescendant');
      this.message.textContent = count ? '' : this.dataset.empty;
      this.status.textContent = count ? this.dataset.count.replace('__COUNT__', String(count)) : this.dataset.empty;
      this.setAllLink(query);
    }
    setAllLink(query) {
      const url = new URL(this.form.action, window.location.origin);
      url.search = new URLSearchParams({ q: query, type: 'product', 'options[prefix]': 'last' }).toString();
      this.allLink.href = url.href;
    }
    onKeydown(event) {
      if (event.isComposing) return;
      if (event.key === 'Enter' && !this.panel.hidden && this.activeIndex >= 0) {
        const target = this.results.querySelectorAll('.up-search-result')[this.activeIndex];
        if (target) { event.preventDefault(); target.click(); }
        return;
      }
      if (!['ArrowDown', 'ArrowUp'].includes(event.key)) return;
      const links = [...this.results.querySelectorAll('.up-search-result')];
      if (!links.length) return;
      event.preventDefault();
      this.open();
      const direction = event.key === 'ArrowDown' ? 1 : -1;
      this.activeIndex = this.activeIndex < 0 ? (direction > 0 ? 0 : links.length - 1) : (this.activeIndex + direction + links.length) % links.length;
      links.forEach((link, index) => link.setAttribute('aria-selected', String(index === this.activeIndex)));
      const active = links[this.activeIndex];
      this.input.setAttribute('aria-activedescendant', active.id);
      active.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    open() {
      if (!this.input.value.trim()) return;
      this.closest('theme-header')?.querySelectorAll('.up-mega-disclosure[open]').forEach(detail => { detail.open = false; });
      if (this.panel.hidden) document.dispatchEvent(new CustomEvent('up:search-open', { detail: { source: this } }));
      this.panel.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
      this.updateRoom();
    }
    queueRoomUpdate() {
      if (this.panel.hidden || this.roomFrame) return;
      this.roomFrame = requestAnimationFrame(() => {
        this.roomFrame = null;
        if (this.isConnected && !this.panel.hidden) this.updateRoom();
      });
    }
    updateRoom() {
      const viewport = window.visualViewport;
      const bottom = viewport ? viewport.height + viewport.offsetTop : window.innerHeight;
      const top = this.panel.getBoundingClientRect().top;
      const room = Math.max(120, Math.floor(bottom - top - 12));
      this.style.setProperty('--up-search-room', `${room}px`);
    }
    close() {
      clearTimeout(this.focusTimer);
      cancelAnimationFrame(this.roomFrame);
      this.roomFrame = null;
      this.cancelRequest();
      if (!this.panel || !this.input) return;
      this.panel.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-activedescendant');
      this.activeIndex = -1;
      this.results.querySelectorAll('[aria-selected=true]').forEach(link => link.setAttribute('aria-selected', 'false'));
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["up-mega-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('up-mega-navigation')) {
    customElements.define('up-mega-navigation', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.disclosures = [...this.querySelectorAll('.up-mega-disclosure')];
        this.hoverQuery = matchMedia('(min-width: 1068px) and (hover: hover) and (pointer: fine)');
        this.keyboardActive = false;
        this.disclosures.forEach((detail) => {
          const summary = detail.querySelector('summary');
          detail.addEventListener('pointerenter', (event) => {
            if (this.hoverQuery.matches && event.pointerType !== 'touch') this.open(detail, true);
          }, options);
          detail.addEventListener('pointerleave', (event) => {
            if (!this.hoverQuery.matches || event.pointerType === 'touch') return;
            clearTimeout(this.closeTimer);
            this.closeTimer = setTimeout(() => {
              if (!(this.keyboardActive && detail.contains(document.activeElement))) this.close(detail);
            }, 180);
          }, options);
          summary.addEventListener('click', (event) => {
            event.preventDefault();
            if (detail.open && this.hoverOpened === detail && event.detail > 0) this.hoverOpened = null;
            else if (detail.open) this.close(detail);
            else this.open(detail);
          }, options);
          summary.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowDown') {
              event.preventDefault();
              this.open(detail);
              detail.querySelector('.up-mega-panel a')?.focus();
            }
          }, options);
          detail.addEventListener('toggle', () => {
            summary.setAttribute('aria-expanded', String(detail.open));
            if (detail.open) this.disclosures.forEach((other) => { if (other !== detail) this.close(other); });
          }, options);
          detail.addEventListener('focusout', () => {
            queueMicrotask(() => { if (this.isConnected && this.keyboardActive && !detail.contains(document.activeElement)) this.close(detail); });
          }, options);
        });
        this.addEventListener('keydown', (event) => {
          this.keyboardActive = true;
          if (event.key === 'Escape') {
            const active = this.disclosures.find((detail) => detail.open);
            if (active) {
              event.preventDefault();
              event.stopPropagation();
              this.closeAll();
              active.querySelector('summary').focus();
            }
          }
        }, options);
        this.addEventListener('pointerdown', () => { this.keyboardActive = false; }, options);
        this.addEventListener('focusout', () => {
          queueMicrotask(() => { if (this.isConnected && this.keyboardActive && !this.contains(document.activeElement)) this.closeAll(); });
        }, options);
        this.querySelector('.up-mega-extra')?.addEventListener('pointerenter', () => {
          if (this.hoverQuery.matches) this.closeAll();
        }, options);
        document.addEventListener('pointerdown', (event) => { if (!this.contains(event.target)) this.closeAll(); }, options);
        window.addEventListener('resize', () => { if (window.innerWidth < 1068) this.closeAll(); }, options);
        this.addEventListener('shopify:block:select', (event) => {
          const item = event.target.closest('.up-mega-item');
          if (item && window.innerWidth >= 1068) this.open(item.querySelector('details'));
        }, options);
      }
      disconnectedCallback() {
        this.events?.abort();
        clearTimeout(this.closeTimer);
      }
      open(detail, fromHover = false) {
        clearTimeout(this.closeTimer);
        this.disclosures.forEach((other) => { if (other !== detail) this.close(other); });
        detail.open = true;
        this.hoverOpened = fromHover ? detail : null;
        detail.querySelector('summary').setAttribute('aria-expanded', 'true');
      }
      close(detail) {
        detail.open = false;
        if (this.hoverOpened === detail) this.hoverOpened = null;
        detail.querySelector('summary').setAttribute('aria-expanded', 'false');
      }
      closeAll() {
        clearTimeout(this.closeTimer);
        this.disclosures.forEach((detail) => this.close(detail));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["up-return-title"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__upReturnTitleInitialized) return;
    const element = document.getElementById('up-return-title-config');
    if (!element) return;
    let config;
    try { config = JSON.parse(element.textContent); } catch (_) { return; }
    window.__upReturnTitleInitialized = true;

    let hasItems = Number(config.itemCount) > 0;
    let originalTitle = document.title;
    let away = false;
    let ready = false;
    let suspended = false;
    let dirty = false;
    let revision = 0;
    let cartTimer;
    let request;
    let marqueeTimer;
    let marqueeText = '';
    let marqueeUnits = [];
    let marqueeOffset = 0;
    const segmenter = typeof Intl.Segmenter === 'function'
      ? new Intl.Segmenter(undefined, { granularity: 'grapheme' }) : null;

    function stopMarquee() {
      clearTimeout(marqueeTimer);
      marqueeText = '';
      marqueeUnits = [];
      marqueeOffset = 0;
    }

    function moveTitleLeft() {
      if (!away || !ready || !document.hidden || suspended || !marqueeText) return;
      marqueeOffset = (marqueeOffset + 1) % marqueeUnits.length;
      document.title = [...marqueeUnits.slice(marqueeOffset), ...marqueeUnits.slice(0, marqueeOffset)].join('');
      marqueeTimer = setTimeout(moveTitleLeft, 180);
    }

    function startMarquee(title) {
      if (title === marqueeText) return;
      stopMarquee();
      marqueeText = title;
      const track = `${title} · `;
      marqueeUnits = segmenter
        ? Array.from(segmenter.segment(track), part => part.segment) : Array.from(track);
      document.title = track;
      marqueeTimer = setTimeout(moveTitleLeft, 180);
    }

    function showReturnTitle() {
      if (!away || !ready || !document.hidden || suspended) return;
      let title = config.labels.home;
      if (hasItems) title = config.labels.cart;
      else if (config.pageType === 'product' && config.productTitle) {
        title = config.labels.product.replace('__PRODUCT__', () => config.productTitle);
      } else if (config.pageType === 'search') title = config.labels.search;
      startMarquee(title);
    }

    function cancelCartRequest() {
      clearTimeout(cartTimer);
      request?.abort();
      request = null;
      revision += 1;
    }

    function acceptCart(cart) {
      if (!cart || !Number.isInteger(cart.item_count) || cart.item_count < 0) return false;
      cancelCartRequest();
      dirty = false;
      hasItems = cart.item_count > 0;
      showReturnTitle();
      return true;
    }

    function queueCartRequest() {
      cancelCartRequest();
      if (!dirty || !away || !document.hidden || suspended) return;
      const version = revision;
      cartTimer = setTimeout(async () => {
        if (version !== revision || !document.hidden || suspended) return;
        const controller = new AbortController();
        request = controller;
        const timeout = setTimeout(() => controller.abort(), 5000);
        try {
          const response = await fetch(config.cartUrl, {
            credentials: 'same-origin', cache: 'no-store',
            headers: { Accept: 'application/json' }, signal: controller.signal
          });
          if (!response.ok) return;
          const cart = await response.json();
          if (version === revision && !controller.signal.aborted && !suspended) acceptCart(cart);
        } catch (_) {
        } finally {
          clearTimeout(timeout);
          if (request === controller) request = null;
        }
      }, 125);
    }

    function markCartDirty(event) {
      if (acceptCart(event?.detail?.cart)) return;
      dirty = true;
      queueCartRequest();
    }

    function restoreTitle() {
      stopMarquee();
      cancelCartRequest();
      if (away) document.title = originalTitle;
      away = false;
      ready = false;
    }

    function handleVisibility() {
      if (!document.hidden) {
        restoreTitle();
        return;
      }
      if (away || suspended) return;
      originalTitle = document.title;
      away = true;
      ready = true;
      showReturnTitle();
      queueCartRequest();
    }

    document.addEventListener('visibilitychange', handleVisibility);
    document.addEventListener('cart:item-added', event => {
      if (acceptCart(event.detail?.cart)) return;
      cancelCartRequest();
      hasItems = true;
      dirty = false;
      showReturnTitle();
    });
    document.addEventListener('line-item:change:end', markCartDirty);
    document.addEventListener('cart:refresh', markCartDirty);
    window.addEventListener('pagehide', () => {
      suspended = true;
      restoreTitle();
    });
    window.addEventListener('pageshow', event => {
      suspended = false;
      if (event.persisted) dirty = true;
      handleVisibility();
    });
    handleVisibility();
  })();
  } catch(e) { console.error(e); }
})();

})();
